import register from '../../../../global/js/registry';
export default register('o-kb-startpage-stage', () => import(/* webpackMode: "lazy" */ './o-kb-startpage-stage.controller'));
